import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'antd'

const ChecCol = ({ children, offset, pull, push, span, className }) => (
  <Col
    offset={offset}
    pull={pull}
    push={push}
    span={span}
    className={className}
  >
    {children}
  </Col>
)

ChecCol.defaultProps = {
  offset: 0,
  pull: 0,
  push: 0,
  span: 3,
  children: [],
}

ChecCol.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  offset: PropTypes.number,
  pull: PropTypes.number,
  push: PropTypes.number,
  span: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default ChecCol
